<template>
  <div class="flex flex-col pt-0 p-4 pb-4 gap-4">
    <div class="rounded-xl relative w-full overflow-hidden">
      <img src="@/assets/images/daily-reward-banner.png" class="w-full" />
      <div class="absolute bottom-0 left-0 flex items-start flex-col p-4 text-left">
        <p class="text-base font-semibold text-DARK-BLUE">Ahoy, Matey! Ye Daily Booty Awaits!</p>
        <p class="text-sm font-medium text-GREY w-full">
          Don’t be greedy—come back tomorrow for more!
        </p>
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <div v-if="false" class="flex items-center gap-3">
        <button
          v-for="i in 4"
          class="flex flex-col w-1/4-gap-3 items-center justify-center rounded-md py-1.5"
          :class="i === 1 ? 'bg-daily-reward-active' : 'bg-DARK-BLUE'"
        >
          <p class="text-sm font-bold text-white">{{ i }}</p>
          <p class="text-white text-xs">Week</p>
        </button>
      </div>
      <div class="flex items-center gap-3 flex-wrap">
        <button
          v-for="i in 10"
          class="flex w-1/4-gap-3 flex-col items-center justify-center rounded-md py-1.5 gap-2.5"
          :class="
            gameStore.lastDailyRewardDay == i - 1 && !gameStore.lastDailyRewardClaimed
              ? 'bg-daily-reward-active'
              : 'bg-DARK-BLUE'
          "
        >
          <p
            class="text-sm"
            :class="gameStore.lastDailyRewardDay < i ? 'text-white' : 'text-LIGHT-PURPLE'"
          >
            Day {{ i }}
          </p>
          <img
            v-if="gameStore.lastDailyRewardDay < i"
            src="@/assets/icons/token-2.svg"
            class="w-5 h-5 object-contain contrast-50"
          />
          <img v-else src="@/assets/icons/check-icon.svg" class="w-5 h-5 object-contain contrast-50" />
          <p
            class="text-xs"
            :class="gameStore.lastDailyRewardDay < i ? 'text-white' : 'text-LIGHT-PURPLE'"
          >
            +{{ tokenFormatter(dailyRewards[i - 1]) }}
          </p>
        </button>
        <button
          class="flex w-1/2-gap-3 flex-col items-center justify-center rounded-md py-1.5 gap-2.5 bg-new-character-reward"
        >
          <p class="text-sm text-white">Day 11</p>
          <img src="@/assets/icons/token-2.svg" class="w-5 h-5 object-contain" />
          <p class="text-white text-xs">+ {{ tokenFormatter(dailyRewards[10]) }}</p>
        </button>
      </div>
      <button
        class="bg-[#5959F0] text-sm rounded-lg text-white py-3 w-full"
        :disabled="gameStore.lastDailyRewardClaimed"
        @click="claim"
      >
        {{ gameStore.lastDailyRewardClaimed ? 'Come Back Tomorrow' : 'Claim' }}
        <!-- active:bg-[#4444E7] -->
      </button>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { useGameStore } from '@/stores/game'
import { tokenFormatter } from '@/utils'

const gameStore = useGameStore()

const dailyRewards = [500, 1000, 2500, 5000, 15000, 25000, 100000, 250000, 500000, 1000000, 5000000]

const claim = () => {
  gameStore.claimDaily()
}
</script>
<style></style>
